import { createApp } from 'vue';
import App from './App.vue';
import './styles/global.css';

createApp(App).mount('#app');
